import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { SsoDomainService } from '../../../core/services/sso-domain.service';
import { LoadingService } from '../../../core/services/loading.service';
import { AsyncPipe } from '@angular/common';
import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';
import { blockedDomainsValidator } from '../../../core/validators/blocked-domain.validator';

@Component({
  selector: 'app-add-domain-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    AsyncPipe,
    LoadingSpinnerComponent
  ],
  templateUrl: './add-domain-dialog.component.html',
  styleUrl: './add-domain-dialog.component.css',
})
export class AddDomainDialogComponent {
  addDomainForm: FormGroup;
  errorMessage: string = '';
  isSubmitting: boolean = false;
  private ssoDomainService = inject(SsoDomainService);
  loadingService = inject(LoadingService);
  

  constructor(private dialogRef: MatDialogRef<AddDomainDialogComponent>, private fb: FormBuilder) {
    this.addDomainForm = this.fb.group({
      domain: ['', [
        Validators.required, 
        Validators.pattern(/^(?!-)(xn--)?([a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,63}$/),
        blockedDomainsValidator(),
      ]]
    });
  }

  onSubmit() {
    if (this.addDomainForm.valid) {
      this.isSubmitting = true;
      this.errorMessage = '';
      
      this.ssoDomainService.createSsoDomain(this.addDomainForm.value.domain).subscribe({
        next: (newDomain) => {
          this.dialogRef.close(newDomain);
        },
        error: (error: string) => {
          console.error('Domain creation error:', error);
          this.isSubmitting = false;
          this.errorMessage = error;
        }
      });
    }
  }

  onCancel() {
    this.dialogRef.close();
  }
}